import { render, staticRenderFns } from "./TheLabels.vue?vue&type=template&id=cb91d60a"
import script from "./TheLabels.vue?vue&type=script&lang=ts"
export * from "./TheLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowAstaLabelValue: require('/usr/src/nuxt-app/components/show/asta/LabelValue.vue').default})
